<template>
  <v-container fluid>
    <v-toolbar class="elevation-1" color="white">
      <v-toolbar-title>Анкеты доступные вам</v-toolbar-title>

      <v-spacer />

      <v-btn
          color="primary"
          dark
          fab
          small
          @click.stop="createItem"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <EditQuestionnaire
          v-model="dialog"
          :questionnaire="editedItem"
          @on-save="onSave"
      />
    </v-toolbar>
    <v-col cols="12" class="my-4">
      <v-row justify="end" align="center">
        <v-row class="mr-1">
          <v-col
              cols="12"
              sm="6"
              md="4"
          >
            <v-text-field
                v-model="pagination.search"
                label="Поиск"
            />
          </v-col>
          <v-col
              cols="12"
              sm="6"
              md="4"
          >
            <v-menu
                ref="fromDate"
                v-model="fromDateMenu"
                :close-on-content-click="true"
                :return-value.sync="pagination.fromDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="pagination.fromDate"
                    label="Начиная с даты"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="pagination.fromDate"
                  no-title
                  scrollable
                  @change="$refs.fromDate.save(pagination.fromDate)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col
              cols="12"
              sm="6"
              md="4"
          >
            <v-menu
                ref="toDate"
                v-model="toDateMenu"
                :close-on-content-click="true"
                :return-value.sync="pagination.toDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="pagination.toDate"
                    label="До даты"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="pagination.toDate"
                  no-title
                  scrollable
                  @change="$refs.toDate.save(pagination.toDate)"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-btn
            v-if="isAdmin"
            :loading="loadingReports"
            :disabled="loadingReports"
            color="primary"
            @click="downloadReport()"
        >
          Загрузить Excel Файл
        </v-btn>
      </v-row>
    </v-col>
    <v-data-table
        :headers="headers"
        :items="questionnaires"
        :items-per-page="pagination.itemsPerPage"
        :options.sync="pagination"
        :server-items-length="total"
        :loading="loading"
        no-results-text="Нет данных"
        no-data-text="Нет данных"
        :footer-props="footerProps"
        calculate-widths
        class="elevation-1"
        @click:row="editItem"
    >
      <template v-slot:item.petition_reason="{ item }">
        {{ getTextFromIndex(petitionReasons, item.petition_reason) }}
      </template>
      <template v-slot:item.marital_status="{ item }">
        {{ getTextFromIndex(maritalStatuses, item.marital_status) }}
      </template>
      <template v-slot:item.human_trafficking_type="{ item }">
        {{ getTextFromIndex(humanTraffickingTypes, item.human_trafficking_type) }}
      </template>
      <template v-slot:item.domestic_violence_type="{ item }">
        {{ getTextFromIndex(domesticViolenceTypes, item.domestic_violence_type) }}
      </template>
      <template v-slot:item.hot_line="{ item }">
        {{ item.hot_line ? 'Да' : 'Нет' }}
      </template>
      <template v-slot:item.asylum="{ item }">
        {{ item.asylum ? 'Да' : 'Нет' }}
      </template>
      <template v-slot:item.created_at="{ item }">
        <p class="min-width-145">
          {{ moment(item.created_at).format('YYYY-MM-DD, HH:mm') }}
        </p>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from 'moment'
import petitionReasons from '@/enum/petitionReasons';
import maritalStatuses from '@/enum/maritalStatuses';
import humanTraffickingTypes from '@/enum/humanTraffickingTypes'
import domesticViolenceTypes from '../enum/domesticViolenceTypes'
import EditQuestionnaire from '@/modals/EditQuestionnaires'
import {mapGetters} from 'vuex';


export default {
  name: 'Questionnaires',
  components: {
    EditQuestionnaire,
  },
  data() {
    return {
      toDateMenu: false,
      fromDateMenu: false,
      moment: moment,
      petitionReasons: petitionReasons,
      maritalStatuses: maritalStatuses,
      humanTraffickingTypes: humanTraffickingTypes,
      domesticViolenceTypes: domesticViolenceTypes,
      footerProps: {
        'items-per-page-options': [10, 20, 30, 50],
        'items-per-page-text': 'Элементов на одной странице:',
        'show-current-page': true,
      },
      headers: [
        { text: 'Имя', value: 'name' },
        { text: 'Предоставленная услуга', value: 'service_provided', align: 'center', width: 200 },
        { text: 'Обращение', value: 'primacy', align: 'center', width: 120 },
        { text: 'Кто обратился?', value: 'who_called', align: 'center', width: 150 },
        { text: 'Пол', value: 'gender' },
        { text: 'Возраст', value: 'age' },
        { text: 'Семейное положение', value: 'marital_status', align: 'center' },
        { text: 'Национальность', value: 'nationality', align: 'center' },
        { text: 'Образование', value: 'education' },
        { text: 'Соц. статус', value: 'social_status' },
        { text: 'Место рождения', value: 'place_of_birth_type' },
        { text: 'Название места', value: 'place_of_birth' },
        { text: 'Причина обращения', value: 'petition_reason', filterable: true, },
        { text: 'Причина обращения другое', value: 'petition_reason_other' },
        { text: 'Тип торговли людьми', value: 'human_trafficking_type', align: 'center' },
        { text: 'Домашнее насилие', value: 'domestic_violence_type' },
        { text: 'Домашнее насилие другое', value: 'domestic_violence_other' },
        // { text: 'Как нас нашли', value: 'how_find' },
        { text: 'Горячая линия', value: 'hot_line' },
        { text: 'Предоставлено убежище', value: 'asylum' },
        { text: 'Автор', value: 'author.firstname' },
        { text: 'Создан', value: 'created_at' },
      ],
      questionnaires: [],
      deleteDialog: false,
      loading: true,
      loadingReports: false,
      dialog: false,
      deletedItem: {},
      editedItem: {},
      total: 0,
      pagination: {
        search: '',
        fromDate: moment().startOf('year').format('YYYY-MM-DD'),
        toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
        itemsPerPage: 10,
        page: 1,
      },
    }
  },
  watch: {
    pagination: {
      handler () {
        this.refresh()
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'security/isAdmin',
    })
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh () {
      this.loading = true
      this.$store.dispatch('questionnaires/getList', this.pagination)
      .then(({ data, meta }) => {
        this.loading = false
        this.questionnaires = data
        this.total = parseInt(meta.total, 10)
      })
    },
    getTextFromIndex(enums, index) {
      if (index) {
        const find = enums.find((findItem) => findItem.value.toString() === index)
        return find.text
      } else {
        return ''
      }
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.deletedItem = Object.assign({}, item)
      this.deleteDialog = true
    },

    async deleteOnModal() {
      this.loading = true
      await this.$store.dispatch('questionnaires/delete', this.deletedItem)
      this.refresh()
      this.deleteDialog = false
      this.loading = false
    },

    createItem () {
      this.$router.push('/');
    },

    onSave () {
      this.refresh()
    },

    toggleSorting () {
      this.pagination.descending = !this.pagination.descending
    },
    async downloadReport () {
      try {
        this.loadingReports = 'loading'
        await this.$store.dispatch('questionnaires/download', this.pagination);
        this.loadingReports = false
      } catch (err) {
        this.$toasted.error('Что то пошло не так')
        this.loadingReports = false
      }
    }
  },
}
</script>

<style scoped>
.min-width-145 {
  min-width: 145px;
}
</style>
